export default __webpack_public_path__ + "static/media/token.6f39484b.png";